module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1613"
  }, [_c('span', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("From ")]), _vm._v("Our House to Your House")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("It is 1959. It is the cusp of the coming revolution.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("We still like Ike. We are still afraid of Sputnik.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("We read "), _c('em', [_vm._v("Life ")]), _vm._v("magazine and "), _c('em', [_vm._v("Sports Illustrated")])]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("where the athletes grow up shooting hoops")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("in the driveway, playing catch in the backyard.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("We sit on our sectional sofa. My mother loves")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Danish modern. Our pants have cuffs. Our hair")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("is short. We are smiling and we mean it. I am")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("a guard. My father is my coach. I am sitting")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("next to him on the bench. I am ready to go in.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("My sister will cheer. My mother will make")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("the pre-game meal from "), _c('em', [_vm._v("The Joy of Cooking")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Buster is a good dog. We are all at an angle.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("We are a family at an angle. Our clothes are")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("pressed. We look into the eye of the camera.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("“Look ’em in the eye,” my father teaches us.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("All we see ahead are wins, good grades,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Christmas. We believe in being happy. We")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("believe in mowing the lawn, a two-car garage,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("a freezer, and what the teacher says. There is")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("nothing on the wall. We are facing away")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("from the wall. The jungle is far from home.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Hoses are for cleaning the car, watering")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("the gardens. My sister walks to school. My")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("father and I lean into the camera. My mother")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("and sister sit up straight. Ike has kept us")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("safe. In the spring, we will have a new car,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("a Plymouth Fury with whitewalls and a vinyl top.")]), _vm._v(" "), _c('p', {
    staticClass: "C1529"
  }, [_c('span', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('img', {
    staticClass: "Image2",
    attrs: {
      "alt": "",
      "src": "html/images/Image_20_0.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b8a1f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/10_From_Our.vue
// module id = 84
// module chunks = 0